/* eslint-disable max-len */
import { FilePdfOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostResp, nzDokoncit, nzdownloadPDF } from 'services/nezarazenyUcet/nuZapis';
import formatNumber from 'utils/formatNumber';

interface IUCDAL {
    zadostData?: IZadostResp;
}

const UCDAL: React.FC<IUCDAL> = props => {
    const history = useHistory();
    const [form] = useForm();
    const { zadostData } = props;
    const [errStatus, setErrStatus] = useState<number>();
    const [showConfirmation, setShowconfirmation] = useState<boolean>();
    const [loading, setLoading] = useState<boolean>(false);
    const { token } = useParams<{ token: string }>();

    const routeChange = () => {
        let path = zadostData?.zadostid
            ? '/nezarazeny-ucet-zapis/idzadost/' + zadostData.zadostid
            : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (data: any) => {
        console.log(data);
        setLoading(true);
        setShowconfirmation(false);
        nzDokoncit(data.ucet, token)
            .then(() => {
                setShowconfirmation(true);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            })
            .finally(() => setLoading(false));
    };

    const protokolDownload = () => {
        setLoading(true);
        nzdownloadPDF('pdf', token, 'protokol')
            .then(() => {
                setLoading(false);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    const fakturaDownload = () => {
        setLoading(true);
        nzdownloadPDF('pdf', token, 'faktura')
            .then(() => {
                setLoading(false);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    console.log(zadostData);

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : showConfirmation ? (
                <>
                    <Paragraph
                        style={{
                            display: 'block',
                            marginBottom: 16
                        }}
                        text={`Vámi podaná žádost o Zápis změny údajů evidovaných o majiteli nezařazeného účtu byla dokončena. Na odkazu uvedeném níže si můžete stáhnout výsledek služby a daňový doklad o zaplaceném poplatku. Vyhotovené výsledky služby budou k dispozici do ${moment(
                            zadostData?.platnostDo
                        ).format('DD.MM.YYYY')}.`}
                    />
                    <Paragraph
                        style={{
                            display: 'block',
                            marginBottom: 16
                        }}
                        text="Po uplynutí této lhůty bude odkaz zneplatněn a nelze ho obnovit. Informace o zapsaných údajích můžete v budoucnu získat prostřednictvím žádosti o výpis z nezařazeného účtu. "
                    />
                    <div className="files">
                        <Row className="file-row" align="middle">
                            <Col span={1} className="file-detail" onClick={protokolDownload}>
                                <FilePdfOutlined />
                            </Col>
                            <Col span={11} className="file-detail" onClick={protokolDownload}>
                                <Paragraph text="Protokol.pdf" strong={true} />
                            </Col>
                            <Col span={10}>
                                <></>
                            </Col>
                        </Row>

                        <Row className="file-row" align="middle">
                            <Col span={1} className="file-detail" onClick={fakturaDownload}>
                                <FilePdfOutlined />
                            </Col>
                            <Col span={11} className="file-detail" onClick={fakturaDownload}>
                                <Paragraph text="Faktura.pdf" strong={true} />
                            </Col>
                            <Col span={10}>
                                <></>
                            </Col>
                        </Row>
                    </div>
                </>
            ) : (
                <LoadingWrapper loading={loading}>
                    <FormWrapper
                        onFinish={onFinish}
                        requiredMark={false}
                        colon={false}
                        outForm={form}
                        labelAlign="left"
                        layoutPosition="horizontal"
                    >
                        <InputComponent
                            name="ciuc"
                            label="Identifikace nezařazeného majetkového účtu"
                            initialValue={zadostData?.rcma}
                            disabled={true}
                            notRequired={true}
                            className="label-long"
                        />
                        <InputComponent
                            label="E-mail žadatele"
                            name="email"
                            initialValue={zadostData?.email ? zadostData.email : ''}
                            disabled={true}
                            notRequired={true}
                        />
                        <InputComponent
                            label="Telefon žadatele"
                            notRequired={true}
                            name="telefon"
                            disabled={true}
                            initialValue={zadostData?.telefon ? formatNumber(zadostData.telefon) : ''}
                        />

                        {zadostData?.zmenosudaj && (
                            <>
                                <h3>
                                    <TranslateText>
                                        Zápis změny evidovaných údajů u majitele nezařazeného účtu
                                    </TranslateText>
                                </h3>
                                <InputComponent
                                    label="Rodné číslo"
                                    name="rodnecislo"
                                    initialValue={zadostData?.rodnecislo ? zadostData.rodnecislo : ''}
                                    disabled={true}
                                    notRequired={true}
                                />
                                <InputComponent
                                    label="Jméno"
                                    name="jmeno"
                                    initialValue={zadostData?.jmeno ? zadostData.jmeno : ''}
                                    disabled={true}
                                    notRequired={true}
                                />
                                <InputComponent
                                    label="Příjmení"
                                    name="prijmeni"
                                    initialValue={zadostData?.prijmeni ? zadostData.prijmeni : ''}
                                    disabled={true}
                                    notRequired={true}
                                />
                                <Paragraph
                                    style={{
                                        fontWeight: 'bold'
                                    }}
                                    text="Adresa"
                                />
                                <InputComponent
                                    label="Ulice a číslo"
                                    name="ulice"
                                    initialValue={zadostData?.ulice ? zadostData.ulice : ''}
                                    disabled={true}
                                    notRequired={true}
                                />
                                <InputComponent
                                    label="Obec"
                                    name="mesto"
                                    initialValue={zadostData?.mesto ? zadostData.mesto : ''}
                                    disabled={true}
                                    notRequired={true}
                                />
                                <InputComponent
                                    label="PSČ"
                                    name="psc"
                                    initialValue={zadostData?.psc ? zadostData.psc : ''}
                                    disabled={true}
                                    notRequired={true}
                                />
                                <InputComponent
                                    label="Stát"
                                    name="stat"
                                    initialValue={zadostData?.stat ? zadostData.stat : ''}
                                    disabled={true}
                                    notRequired={true}
                                />
                            </>
                        )}
                        {zadostData?.zmenbankuc && (
                            <>
                                <h3>
                                    <TranslateText>
                                        Zápis změny bankovního účtu u majitele nezařazeného účtu
                                    </TranslateText>
                                </h3>
                                <SelectComponent
                                    labelParagraph="Bankovní účet"
                                    name="ucet"
                                    data={
                                        zadostData?.bankucty?.length
                                            ? zadostData?.bankucty!.map(e => {
                                                  return {
                                                      labelcz: e.ciuc
                                                          ? `${e.pred ? e.pred + '-' : ''}${e.ciuc}/${e.kcca}`
                                                          : '',
                                                      value: e.idbankucet || ''
                                                  };
                                              })
                                            : []
                                    }
                                    isFormItem={true}
                                    rules={[
                                        {
                                            required: true,
                                            message: <TranslateText>{'NEVALIDNI_POVINNA_POLOZKA'}</TranslateText>
                                        }
                                    ]}
                                />
                            </>
                        )}
                        <Row className="statement-buttons-row">
                            <ButtonComponent htmlType="submit" buttontext="Dokončit a odeslat" />
                        </Row>
                    </FormWrapper>
                </LoadingWrapper>
            )}
        </>
    );
};

export default UCDAL;
